import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, switchMap } from 'rxjs';
import { cardHistory } from 'src/app/interfaces/cardHistory';
import { CardService } from 'src/app/services/card.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-card-history',
  templateUrl: './card-history.component.html',
  styleUrls: ['./card-history.component.scss']
})
export class CardHistoryComponent implements OnInit {
  /**
   * is the Page finished Loading
   */
  finishedLoading: boolean = false;
  /**
   * The Data to be displayed
   */
  dataSource: MatTableDataSource<any>;
  /**
 * The Columns of the Table to be displayed
 */
  displayedColumns = ['number', 'ownendByRef', 'modifiedByRef', 'state', 'created'];
  /**
   * constructor
   * Get the data via the URL Params 
   * @param overlayService 
   * @param route 
   * @param cardSerive 
   */
  constructor(
    private overlayService: OverlayService,
    private route: ActivatedRoute,
    private cardSerive: CardService
  ) {

    this.route.params.pipe(
      switchMap((params:HttpParams)=>{
          return this.cardSerive.getHistory(params['id'])
      })
    ).subscribe({
      next: (history: cardHistory)=>{
        this.finishedLoading = true
        this.dataSource = new MatTableDataSource(history);
      },
      error: err =>{
        console.log("error: ", err);
        this.overlayService.openErrorDialog("Fehler beim Laden", "Versuchen Sie es bitte später noch einmal. Sollte das Problem nicht in absehbarer Zeit behoben sein, schreiben Sie uns eine E-Mail an: support@plusservices.de", "Zurück")
      }
    })
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {


  }

}
